import { render, staticRenderFns } from "./sendPageAudio.vue?vue&type=template&id=336d5da4&"
import script from "./sendPageAudio.vue?vue&type=script&lang=js&"
export * from "./sendPageAudio.vue?vue&type=script&lang=js&"
import style0 from "./sendPageAudio.vue?vue&type=style&index=0&id=336d5da4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports